// @ts-strict-ignore
import React from "react";

import styled from "@emotion/styled";
import { color } from "@hubble/tokens/web";
import { HubbleProvider } from "@hubble/web";
import Accordion from "components/parts/HubbleAccordion";
import Markdown from "components/parts/Markdown";
import { HubbleBody, HubbleDisplay } from "components/parts/Typography";
import { Container } from "components/parts/Container";
import type { FAQSectionContentModel } from "types/contentful";
import type { EntryCollection } from "contentful";
import { useTranslations } from "i18n";

export const FAQContainer = styled.div`
  padding: 100px 0px;
  background-color: black;
`;

export const ColoredSpan = styled.span`
  color: ${color.base.brandCyan};
`;

interface FAQProps {
  data?: EntryCollection<FAQSectionContentModel>;
  cleanedFAQArray?: Array<Record<string, any>>;
}

const HowToBuyFAQ = ({ data, cleanedFAQArray }: FAQProps) => {
  const t = useTranslations("how-to-buy");
  const markdownConfig = {
    p: (props) => <HubbleBody {...props} style={{ margin: "revert" }} />,
    li: (props) => <HubbleBody as="li" {...props} />,
    link: (props) => <HubbleBody {...props} />
  };

  let finalFAQItems = (
    data?.items.find((item) => item.fields.pageName === "Institutional").fields
      .faqItems as any
  )?.map(({ fields: { questionTitle, answer } }) => ({
    questionTitle,
    answer
  }));

  if (Array.isArray(cleanedFAQArray)) {
    finalFAQItems = [...cleanedFAQArray];
  }

  return (
    <HubbleProvider scheme="dark">
      <FAQContainer>
        <Container maxWidth="784px">
          <HubbleDisplay
            style={{ textAlign: "center" }}
            semiBold
            size="xl"
            mb={12}
          >
            {t("faqTitle")}
            <ColoredSpan> {t("faqSubtitle")}</ColoredSpan>
          </HubbleDisplay>
          <Accordion>
            {finalFAQItems.map(({ questionTitle, answer }) => (
              <Accordion.Collapse
                title={questionTitle}
                key={questionTitle}
                boldTitle
              >
                <Markdown source={answer} config={markdownConfig} />
              </Accordion.Collapse>
            ))}
          </Accordion>
        </Container>
      </FAQContainer>
    </HubbleProvider>
  );
};

export default HowToBuyFAQ;
